export const GP_MODAL_VARIANT_NO_THREATS = 'noThreats' as const;

export type GatorProtectNoThreatsModalProps = {
  onClose: () => void;
  onPrimary: () => void;
  pricingFootnoteDisplayValue: string;
  isPricingFootnoteLoading?: boolean;
};
